<template>
  <div class="vx-row pb-3" v-show="isCardActiveLocal">
    <div class="vx-col w-full">
      <vs-divider>Subject</vs-divider>
      <vs-collapse class="border">
        <vs-collapse-item id="subjectCollapse">
          <div slot="header">
            Subjects
          </div>
          <div style="overflow: auto;">
            <v-select ref="subjectsDropdown" placeholder="Search / Select Subject to Assign" @search:blur="assignSubject" :options="unassignedSubjects" v-model="subjectsDropdown"></v-select>
            <vs-table  ref="subjectTable" class="vs-con-loading__container" stripe single pagination max-items="10" search :data="assignedSubjects">
              <template slot="thead">
                <vs-th>Subject</vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="assignedSubjects" :key="indextr" v-for="(sub, indextr) in data">
                  <vs-td :data="data[indextr].assignedSubjects">
                    {{sub.label}}
                  </vs-td>
                  <vs-td>
                    <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-x" @click.stop.prevent="areYouSure(sub.value)"></vs-button>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-collapse-item>
      </vs-collapse>
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      libraryResourceId: {
        type: Number
      },
      resourceType: {
        type: String
      }
    },
    data() {
      return {
        subjectsDropdown: 0,
        unassignedSubjects: [],
        assignedSubjects: [],
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {           
          }
        }        
      }      
    },
    watch: {      
      isCardActive: function(val) {
        if(val){
          var self = this;
          this.initValues();
          self.getSubjectsDropdownList(self.libraryResourceId);
        }
      }
    },
    methods: {
      initValues() {
        this.subjectsDropdown= 0;
        this.unassignedSubjects= [];
        this.assignedSubjects= [];
      },
      getSubjectsDropdownList(resourceId) {
        this.initValues();
        const self = this;
        var onSuccess = function (response) {
          self.unassignedSubjects = response.data.filter(function (item) {
            return !item.assigned;
          });
          self.assignedSubjects = response.data.filter(function(item){
            return item.assigned;
          });
        };        
        self.$ajaxGet(self, "LibraryResource/GetCourseDropdownList?resourceId=" + resourceId, onSuccess);
      },
      assignSubject() {
        var self = this;
        if (self.subjectsDropdown.value) {
          self.showLoadingOnElement("subjectTable", 1, "corners");

          var onSuccess = response => {
            self.$vs.notify({
              title: 'Information',
              color: "success",
              text: `Subject Assigned to ${self.resourceType}`,
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check'
            });
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.subjectTable.$el);
            self.getSubjectsDropdownList(self.libraryResourceId);
            self.subjectsDropdown = 0;
          };

          self.$ajaxGet(self, "LibraryResource/AssignToCourse?courseId=" + parseInt(self.subjectsDropdown.value) + "&resourceId=" + self.libraryResourceId , onSuccess, onFinally);
        }
      },
      areYouSure(subjectId) {
        var self = this;
        self.subjectToUnassign = subjectId;
        self.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Attention`,
          text: `Are you sure you want to remove the selected subject from the ${self.resourceType}?`,
          accept: self.unassignSubject,
          acceptText: "Yes",
          cancelText: "No"
        })
      },
      unassignSubject() {
        var self = this;
        self.showLoadingOnElement("subjectTable", 1, "corners");

        var onSuccess = response => {
          self.$vs.notify({
            title: 'Information',
            color: "success",
            text: `Subject Unassigned from ${self.resourceType}`,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-x'
          });
          self.getSubjectsDropdownList(self.libraryResourceId);
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.subjectTable.$el);
          self.getSubjectsDropdownList(self.libraryResourceId);
        };

        self.$ajaxGet(self, "LibraryResource/UnassignFromCourse?courseId=" + self.subjectToUnassign + "&resourceId=" + self.libraryResourceId, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type) {
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
    }
  }

</script>

<style lang="scss">
  
</style>
